
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["header-referral-section__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 0a1 1 0 01.92.608l2.247 5.268 2.319-.932a1 1 0 011.3 1.3l-.985 2.452 5.591 2.384a1 1 0 010 1.84l-5.46 2.329.98 2.44a1 1 0 01-1.3 1.3l-2.403-.965-2.29 5.368a1 1 0 01-1.839 0L8.73 17.878l-2.636 1.06a1 1 0 01-1.3-1.3l1.006-2.504L.608 12.92a1 1 0 010-1.84L5.93 8.81 4.919 6.297a1 1 0 011.3-1.3L8.771 6.02l2.31-5.413A1 1 0 0112 0zm0 3.55l-1.773 4.157a1 1 0 01-1.293.535l-1.285-.516.502 1.247a1 1 0 01-.536 1.293L3.549 12l3.935 1.678a1 1 0 01.536 1.293l-.497 1.237 1.368-.55a1 1 0 011.293.535L12 20.45l1.754-4.113a1 1 0 011.293-.535l1.136.456-.472-1.173a1 1 0 01.535-1.293L20.451 12l-4.335-1.849a1 1 0 01-.536-1.293l.476-1.184-1.052.423a1 1 0 01-1.293-.535L12 3.549z","fill":"currentColor"}})])
          )
        }
      }
    